import React from "react";
import { Page, PageHeader, SkipToContent, PageSidebar, Title } from "@patternfly/react-core";
import PageToolbar from "./PageToolbar";
import Nav from "./Nav";

export default props => {
  const pageId = 'lifecycle-admin-console';
  const title = (
    <Title headingLevel="h1">Life Cycle Admin Console</Title>
  );
  const header = (
    <PageHeader logo={title} headerTools={<PageToolbar />} showNavToggle />
  );
  const sidebar = <PageSidebar nav={<Nav />} theme="light" />;
  const PageSkipToContent = (
    <SkipToContent href={`#${pageId}`}>Skip to Content</SkipToContent>
  );

  return (
    <Page
      header={header}
      sidebar={sidebar}
      isManagedSidebar
      skipToContent={PageSkipToContent}
      mainContainerId={pageId}
    >
      {props.children}
    </Page>
  );
};
